namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_chart_filter, {
		
		background: {
			color: $mol_theme.card,
		},

		Form: {
			padding: $mol_gap.block,
			gap: $mol_gap.space,
		},

		Field: {
			gap: $mol_gap.space,
		},
		
	} )
	
}
